import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve, RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { InvoiceHistoryStore } from './invoice-history.store';

@Injectable()
export class InvoiceHistoryResolver implements Resolve<any> {

  constructor(private invoiceHistoryStore: InvoiceHistoryStore) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    this.invoiceHistoryStore.loadInvoiceHistoryEnabled();

    return of({status: 'invoice-history-resolver'});
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.resolver.ts